//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/Features.SheetMetal.js";
import "../Features/Features.SheetMetal.SheetmetalBaseBuilder.js";
import "../no/Features.js";
let d=[[[0,"BendOptions",0,"Features.SheetMetal.BendOptions",0],[0,"EdgeChain",1,"Section",0],[0,"IsSecondary",1,0],[0,"MiterOptions",0,"Features.SheetMetal.MiterOptions",0],[0,"Section",1,"Section",0],[0,"Sketch",1,"Features.SketchFeature",0],[0,"SweepSide",1,0],[0,"SweepType",1,0],[0,"ThicknessSide",1,0]],[[[],"GetThickness",{R_:{thickness:"Expression"}},0,0],[[],"GetSweepDistance",{R_:{sweep_distance:"Expression"}},0,0],[[],"ValidateBuilderData",{R_:{builder_data_validity:''}},0,0]],[]];
SPLM.Features.SheetMetal.ContourFlangeBuilder = class extends SPLM.Features.SheetMetal.SheetmetalBaseBuilder{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.Features.SheetMetal.ContourFlangeBuilder";
        SPLM.c$d(this.Class,d);d=[];
    }
};

SPLM.Features.SheetMetal.ContourFlangeBuilder.SectionSideOptions = Object.freeze({
    "Left" : "Left", "Right" : "Right"});

SPLM.Features.SheetMetal.ContourFlangeBuilder.SweepSideOptions = Object.freeze({
    "SectionNormalSide" : "SectionNormalSide", "SectionReverseNormalSide" : "SectionReverseNormalSide"});

SPLM.Features.SheetMetal.ContourFlangeBuilder.SweepTypeOptions = Object.freeze({
    "Finite" : "Finite", "Symmetric" : "Symmetric", "ToEnd" : "ToEnd", "Chain" : "Chain"});

export default SPLM;